module.exports = __webpack_public_path__ + "media/images/proposito-logo-horizontal-color-768x132-d66d19ffc09236aff1f71ceb7a4e1f36.png";